import type { WithRequiredFields } from '@ipen-portal/plugin-common';
import type {
  Application,
  AppRoleAssignment,
  Group,
  ServicePrincipal,
  User,
} from '@microsoft/microsoft-graph-types';

export enum SearchResultType {
  Group = 'Group',
  ServicePrincipal = 'ServicePrincipal',
  User = 'User',
}

export type IPenAppRoleAssignment = WithRequiredFields<
  AppRoleAssignment,
  'id' | 'principalDisplayName' | 'principalId' | 'resourceId'
>;

export type MsGraphSearchBatchResponse = {
  responses: MsGraphResponse[];
};
export type MsGraphValueResponse<T> = {
  value: T[];
};
/**
 * The API used by the apim-plugin to fetch multiple endpoints.
 *
 * @public
 */
export type MsIamApi = {
  createServicePrincipalsAppRoleAssignedTo(
    userId: string,
    resourceId: string,
    appRoleId: string,
  ): Promise<IPenAppRoleAssignment>;

  deleteServicePrincipalsAppRoleAssignedTo(
    resourceId: string,
    appRoleId: string,
  ): Promise<Response>;

  getApplication(appId: string): Promise<Application>;

  getAppRoleAssignmentsForApplication(
    appId: string,
  ): Promise<MsGraphValueResponse<IPenAppRoleAssignment>>;

  getMyOwnedObjects(): Promise<MsGraphValueResponse<MsOwnedObject>>;

  getServicePrincipalForApp(appId: string): Promise<ServicePrincipal>;

  listUsers(query?: string): Promise<MsGraphValueResponse<User>>;

  searchServicePrincipals(query?: string): Promise<SearchResult[]>;

  searchUsersAndGroups(query?: string): Promise<SearchResult[]>;

  updateApplication(appObjectId: string, body: unknown): Promise<void>;
};

export type MsOwnedObject = {
  [key: string]: string;
  appId: string;
  displayName: string;
  id: string;
  type: string;
};

export type SearchResult =
  | {
    type: SearchResultType.Group;
    value: Group;
  }
  | {
    type: SearchResultType.ServicePrincipal;
    value: ServicePrincipal;
  }
  | {
    type: SearchResultType.User;
    value: User;
  };

type MsGraphResponse = {
  body: MsGraphValueResponse<Group | ServicePrincipal | User>;
  id: string;
  status: number;
};
